import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export { DoSyncData, GetSyncInfo };

function DoSyncData(onSuccess, onError) {
  const headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL + "/ueblicherlohn/stammdaten/DoSyncData",
      null,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function GetSyncInfo(onSuccess, onError) {
  const headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + "/ueblicherlohn/stammdaten/SyncInfo",
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}
